import { MouseEvent } from 'react';

import { ToggleButton, ToggleButtonGroup, Icons } from '@cast/design-system';

type Props = {
  value: boolean;
  disabled?: boolean;
  onChange: (event: MouseEvent<HTMLElement>) => void;
};

export const EventViewToggle = ({ value, disabled, onChange }: Props) => {
  return (
    <ToggleButtonGroup
      value={value}
      size="sm"
      testId="event-view-toggle"
      onChange={onChange}
      disabled={disabled}
    >
      <ToggleButton
        value={false}
        icon={<Icons.ListBullets />}
        testId="details-btn"
      />
      <ToggleButton
        value={true}
        icon={<Icons.BracketsCurly />}
        testId="json-btn"
      />
    </ToggleButtonGroup>
  );
};
